import { Injectable, Injector } from '@angular/core';
import { CompanyStatus } from '@authority-labs/api-interfaces';
import { Path } from '@authority-labs/enums';
import { ChangeType } from '@check-list/app/classes/enums/change-type.enum';
import { ColumnFilter } from '@check-list/app/classes/models/column-filter.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { CrudService } from '../../shared/services/crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyStatusService extends CrudService<CompanyStatus> {
  statuses: BehaviorSubject<CompanyStatus[]> = new BehaviorSubject([]);
  statusFilters: ColumnFilter[] = [];

  constructor(injector: Injector) {
    super(injector, Path.CompanyStatus, CompanyStatus);

    CompanyStatusService.changesEmitter
      .pipe(filter((event) => event.path === Path.CompanyStatus))
      .subscribe((event) => {
        if (
          [ChangeType.deleted, ChangeType.edited, ChangeType.created].includes(
            event.action
          )
        ) {
          this.getAll().subscribe();
        }
      });
  }

  getAll(): Observable<CompanyStatus[]> {
    return super.getAll().pipe(
      tap((data) => {
        this.statuses.next(
          data.map((status) => this.removeReadonlyFields({ ...status }))
        );
        this.setStatusesFilter(this.statuses.getValue());
      })
    );
  }

  private setStatusesFilter(statuses: CompanyStatus[] = []): void {
    this.statusFilters = statuses.map((item) => ({
      label: item.name,
      value: item.name
    }));
  }
}
